import { Box, Typography } from "@mui/material";
import IntegrationImage from "../../../../integrations/components/IntegrationImage";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const ServerComplianceView = ({ entityData }) => {
  return (
    <Box display={"flex"} flexDirection={"column"} gap={2} pb={2}>
      {entityData?.servicenow_cmdb_data?.pci_cde != null && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>PCI CDE</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.pci_cde ? "Yes" : "No"}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.pci_supporting != null && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>PCI Supporting</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={
                entityData?.servicenow_cmdb_data?.pci_supporting ? "Yes" : "No"
              }
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.pci_supporting_asset != null && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>PCI Supporting Asset</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={
                entityData?.servicenow_cmdb_data?.pci_supporting_asset
                  ? "Yes"
                  : "No"
              }
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.ccpa != null && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>CCPA</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.ccpa ? "Yes" : "No"}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.sox != null && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>SOX</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.sox ? "Yes" : "No"}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.pii != null && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>PII</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.pii ? "Yes" : "No"}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.gdpr != null && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>GDPR</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.gdpr ? "Yes" : "No"}
            />
          </Box>
        </Box>
      )}
      {entityData?.servicenow_cmdb_data?.iso_27001 != null && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>ISO 27001</Typography>
          </Box>
          <Box display={"flex"} gap={2} ml={3}>
            <TextIntegrationStyle
              title={
                <Box display={"flex"}>
                  <IntegrationImage
                    name={"servicenow_cmdb"}
                    width={"12px"}
                    newLogo={true}
                  />
                </Box>
              }
              value={entityData?.servicenow_cmdb_data?.iso_27001 ? "Yes" : "No"}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default ServerComplianceView;
